<script>
  import ActionReportMixin from './ActionReportMixin.vue'

  export default {
    name: 'RbvHotelRfpBidManagerMarkRatesAsLoadedActionReport',
    mixins: [ ActionReportMixin ],
    data () {
      return {
        messages: {
          'OK': 'Success!',
          'NOT_FOUND': `Bid was not found`,
          'ERROR': 'Rates not marked due to an unknown error'
        }
      }
    },
    computed: {
      title () { return this.items.length === 1 ? 'Rates Marked!' : 'There were errors...' },
      message () {
        return this.items.length === 1
          ? 'We were not able to mark rates because of the reason listed below:'
          : `${this.items.length - this.failures} of ${this.items.length} successfully marked.<br /> We were not able to mark others because of the reasons listed below:`
      }
    }
  }
</script>
